import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import bem from '../../../common/bem'
import { isUrlExternal } from '../../../common/genericHelper'

import { Link } from 'react-router'

import './Button.scss'

export default class Button extends Component {

  render() {
    const bemmer = bem('button')
    const { children, className, to } = this.props
    let btnBemmer =  bemmer.element('button').modifier(this.props.type)

    return (typeof to === 'string' && isUrlExternal(to)
      ? <a className={`${btnBemmer} ${className}`} href={to} target='_blank'>{ children }</a>
      : <Link className={`${btnBemmer} ${className}`} to={to}>{ children }</Link>);
  }
}

Button.defaultProps = {
  className: '',
  type: null,
  to: undefined
}

Button.propTypes = {
  type: React.PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
}



// WEBPACK FOOTER //
// ./component/ui/Button/Button.js